import VideoPresenter from "../components/video/presenter/video.js";

const videoComponent = new VideoPresenter({
  renderAfter: `.header`,
  text: `Познакомьтесь с&nbsp;нами за 2 минуты`,
  poster: `/assets/templates/main/videos/promo-video-poster.jpg`,
  src: {
    mp4: `/assets/templates/main/videos/promo-video-720.mp4`
  }
});
videoComponent.init();
